import * as React from 'react';
import { Col, Row } from 'reactstrap';
import AdHocReporter from '../feature/AdHocReporter';
import Page from '../Page';

const AdHocReport = (props: any) => {

    return (
        <React.Fragment>
            <Page>
                <Row>
                    <Col>
                        <AdHocReporter />
                    </Col>
                </Row>
            </Page>
        </React.Fragment>
    );
}

export default AdHocReport;